import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UtilityService} from '../../../core/services/utility.service';

@Component({
	selector: 'app-timer-countdown',
	templateUrl: './timer-countdown.component.html',
	styleUrls: ['./timer-countdown.component.scss']
})
export class TimerCountdownComponent implements OnInit {

	@Input() date: number;
	@Output() OnCountDown = new EventEmitter();
	countDown: any;
	interval: any;

	constructor(private utilityService: UtilityService) {
	}

	ngOnInit(): void {
		this.startCountDown(this.date);
	}

	startCountDown(countDownDate: number) {
		this.countDown = this.utilityService.getTimeFromDate(countDownDate);
		this.OnCountDown.next(this.countDown);
		this.interval = setInterval(() => {
			this.countDown = this.utilityService.getTimeFromDate(countDownDate);
			this.OnCountDown.next(this.countDown);
			if (this.countDown?.hours == '00' && this.countDown?.minutes == '00' && this.countDown?.seconds == '00') {
				clearInterval(this.interval);
			}
		}, 1000);

	}

// tslint:disable-next-line:use-lifecycle-interface
	ngOnDestroy(): void {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}

}
